import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("newsletter", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateNewsletter = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateNewsletter?.destroy();
  },
});
